import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPage from "./LandingPage";
import TokenDashboard from "./TokenDashboard";
import PrivacyPolicy from "./PrivacyPolicy";
import DataDeletion from "./DataDeletion";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/dashboard" element={<TokenDashboard />} />
          <Route path="/fb_privacy" element={<PrivacyPolicy />} />
          <Route path="/fb-privacy" element={<PrivacyPolicy />} />
          <Route path="/fb_data-deletion" element={<DataDeletion />} />
          <Route path="/fb-data-deletion" element={<DataDeletion />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
